import script from "./Circle.vue?vue&type=script&lang=ts&setup=true"
export * from "./Circle.vue?vue&type=script&lang=ts&setup=true"

import "./Circle.vue?vue&type=style&index=0&id=2afdf54c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3010703901/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afdf54c"]])

export default __exports__